// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as CrossSmallComponent} from './CrossSmall.svg';

import Icon, { TIconProps } from '../Icon';

export const IconCrossSmall = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <CrossSmallComponent/>
  </Icon>
));
